import './Badge.css';

export const Badge = ({ icon, children, content }) => {
    return (
        <div className='badge-component'>
            {children}
            {content && <div className='badge'>
                <svg viewBox='0 0 100 100'>
                    <circle cx="50%" cy="50%" r="40%" fill="var(--green-250)" />
                </svg>
            </div>}
        </div>
    )
}